




































































































































































































import { Vue, Component, Lifecycle, Prop, p } from "av-ts";
import { IQuestion, ICourseUser } from "../../interfaces/models";

import { addEventsToQueue, isAdmin } from "../../util";
import QuestionService from "../../services/QuestionService";
import UserService from "../../services/UserService";

import QuestionRater from "./QuestionRater.vue";
import QuestionDetails from "./QuestionDetails.vue";
import QuestionResponse from "./QuestionResponse.vue";
import Fetcher from "../../services/Fetcher";


import TopicChip from "../util/TopicChip.vue";

const _MODAL_NAME = "report_question_modal";

@Component({
    components: {
        QuestionRater,
        QuestionResponse,
        QuestionDetails,
        TopicChip
    }
})
export default class Question extends Vue {
    @Prop question = p<IQuestion>({
        required: true
    });

    @Prop showSpeedDial = p<boolean>({
        default: true
    });

    @Prop showNavBar = p<boolean>({
        default: true
    });

    @Prop preview = p<boolean>({
        default: false
    });

    reason = "";
    pReasonList: string[] | undefined = undefined;
    reasonsUsed: string[] = [];
    networkMessage = "";
    currentUser: ICourseUser;

    userIsFinishedWithQuestion: boolean = false;
    isAuthor: boolean = false;

    updateUserAnswer(wasCorrect: boolean) {
        this.userIsFinishedWithQuestion = wasCorrect;
        if (this.question !== undefined && this.userIsFinishedWithQuestion) {
            this.question.responseCount++;
        }
    }

    get reasonList() {
        return this.pReasonList;
    }

    set reasonList(newList) {
        this.pReasonList = newList;
    }

    get speedDial(): boolean {
        return this.showSpeedDial && this.userIsFinishedWithQuestion && !this.preview;
    }

    nextQuestion() {
        QuestionService.getNextRecommendedQuestion(this.question.id)
            .then(questionId => {
                if (questionId == this.question.id) {
                    addEventsToQueue([{
                        name: "Server Question Response",
                        description: "You may have no more recommended questions",
                        icon: "error"
                    }]);
                } else {
                    this.$router.push({
                        path: `/question/id/${questionId}`
                    });
                }
            });
    }

    closeQuestion() {
        this.$router.push("/question/answer");
    }

    reportQuestion() {
        if (this.reason.length > 0) {
            this.reasonsUsed.push(this.reason);
        }
        if (this.reasonsUsed.length == 0) {
            addEventsToQueue([{
                name: "Not enough reasons",
                description: "You must provide at least one reason.",
                icon: "error"
            }]);
            return;
        }
        QuestionService.reportQuestion(this.question.id, this.reasonsUsed)
            .then(_ => {
                addEventsToQueue([{
                    name: "Question Reported",
                    description: "Question Reported.",
                    icon: "done"
                }]);
                this.reasonsUsed.splice(0, this.reasonsUsed.length);
                this.reason = "";

                this.closeDialog();
            });
    }

    openDialog() {
        const modal = this.$refs[_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    }

    closeDialog() {
        (this.$refs[_MODAL_NAME] as any).close();
    }

    toggleReason(reasonToToggle: string) {
        const reasonIndex = this.reasonsUsed.indexOf(reasonToToggle);
        if (reasonIndex == -1) {
            this.reasonsUsed.push(reasonToToggle);
        } else {
            this.reasonsUsed.splice(reasonIndex, 1);
        }
    }

    reasonIsUsed(reason: string) {
        return this.reasonsUsed.indexOf(reason) >= 0;
    }

    updateReportReasons(reasons: string[]) {
        this.pReasonList = reasons;
    }

    updateUser(user: ICourseUser) {
        this.currentUser = user;
        if (this.currentUser && (this.currentUser.id == this.question.author.id
                || isAdmin(this.currentUser.roles))) {
            this.isAuthor = true;
        }
    }

    @Lifecycle
    created() {
        Fetcher.get(QuestionService.getReportReasons)
            .on(this.updateReportReasons);

        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateUser);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(QuestionService.getReportReasons)
            .off(this.updateReportReasons);
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateUser);
    }

    get bottomSpaceClass(): string {
        if (this.showSpeedDial) {
            return "bottomSpace";
        } else {
            return "";
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/questions/Question.vue